module.exports = __webpack_public_path__ + "img/ICO_lealtad.fd62c3cf.svg";